// this is meant to be triggered from a callback. see "src/components/Marketo/MarketoForm.js" file
export function triggerFormSubmitSuccess(formName, formValues) {
  if (formName && typeof formValues === "object" && formValues !== null) {
    Object.keys(formValues).forEach(function (key) {
      formValues[`form_${key.toLowerCase().trim()}`] = formValues[key] // rename key
      delete formValues[key]
    })
    if (typeof window !== "undefined" && typeof document !== undefined) {
      window.dataLayer.push({
        event: "form_submit_success",
        form_name: formName,
        marketo_form: formValues.form_formid || null,
        ...formValues,
      })
    }
  }
}

// this is meant to be triggered from a callback. see "src/context/auth/authReducer.js" file
export function triggerLoginSuccess(userId) {
  if (typeof window !== "undefined" && typeof document !== undefined) {
    window.dataLayer.push({
      event: "login_success",
      trimble_id: userId,
      logged_in: true,
      method: null,
      user_type: null,
      segments: null,
      user_id: null,
      marketo_id: null,
      salesforce_id: null,
      entitlement_id: null,
      entitlement_status: null,
      employee_range: null,
      company_name: null,
      revenue_range: null,
      company_state: null,
      user_preferences: null,
      user_purchase_history: null,
      days_since_last_login: null,
      licensed_user_count: null,
      days_till_license_expiration: null,
      customer_annual_value: null,
      activation_date: null,
      activation_end_date: null,
      partner_type: null,
      dealer_type: null,
      member_since: null,
      buying_state: null,
      profile_fit: null,
    })
  }
}
